import { useNavigate, Form } from "react-router-dom";
import { Table, Spinner } from "react-bootstrap";
import classes from "./Appointments.module.css";
import { Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import { getAuthToken } from "../../../util/auth";
import { getApiChara } from "../../../util/getApi";
import { toast } from "react-toastify";
import Loader from "../../UI/Loader";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";

const ScheduleAppointment = (props) => {
  const { t } = useTranslation();
  const [searchPara, setSearchPara] = useState('');
  const [patientData, setPatientData] = useState([]);
  const [doctornm, setDoctorNm] = useState({});
  const [doctorData, setdoctorData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [appointmentDate, setAppointmentDate] = useState("");
  const [todayDate, setTodayDate] = useState("");
  const waitingData = props.waitingList;
  const navigate = useNavigate();
  // ✅ Set default current date-time in required format

  useEffect(() => {
    const now = new Date();
    const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);

    setTodayDate(local);
    setAppointmentDate(local);
  }, []);
  const newPatientHandler = () => {
    navigate("new");
  };
  useEffect(() => {
    fetchDoctorList();
  }, []);
  const fetchDoctorList = async () => {
    const token = getAuthToken();
    if (token === null || token === 'EXPIRED') {
      navigate('/');
    }
    const apiChar = getApiChara();
    const apiUrl = `${apiChar}/users/getDoctorsList`;
    setIsLoading(true);
    try {
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Could Not fetch doctor details");
      }
      const doctorData = await response.json();
      const initialDr = doctorData[0];
      setdoctorData(doctorData);
      setDoctorNm(initialDr);
    } catch (error) {
      console.error("Error fetching doctor list data: ", error);
      navigate("/access-denied?errorCode=500&errorMessage=Server%20is%20offline&errorDescription=check%20your%20internet%20connection%20or");
    }
    finally {
      setIsLoading(false); // Hide loader after fetching data
    }
  };
  const onChangeDoctorHandler = (e) => {
    const selectedDoctorId = parseInt(e.target.value, 10); // Ensure selectedDoctorId is parsed as an integer
    const selectedDoctor = doctorData.find((doctor) => doctor.userId === selectedDoctorId);

    if (selectedDoctor) {
      setDoctorNm(selectedDoctor);

    } else {
      console.log("Doctor not found for selected ID:", selectedDoctorId);
    }
  };

  const getSerachParaHandler = (e) => {
    setSearchPara(e.target.value);
  };

  const onSearchPatientHandler = async (e) => {
    e.preventDefault();

    const token = getAuthToken();
    if (token === null || token === 'EXPIRED') {
      navigate('/');
    }
    const apiChar = getApiChara();
    const apiUrl = `${apiChar}/patient/getPatientByFNameOrLNameOrMobile?value=` + searchPara;

    try {
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Could Not fetch details");
      }

      const data = await response.json();
      setPatientData(data);
    } catch (error) {
      console.error("Error fetching patient data: ", error);
    }
    finally {
      setIsLoading(false); // Hide loader after fetching data
    }
  };
  const addPatientToWaitingHandler = async (e, selectedPatient) => {
    e.preventDefault();
    const id = selectedPatient.patientId;

    const isExistPatient = waitingData.some(
      (patient) => patient.patientId.patientId === id
    );

    if (isExistPatient) {
      toast.error(t("Patient already in the waiting list"));
      return;
    }
    const formattedAppointment = appointmentDate.replace("T", " ") + ":00";

    const patientData = {
      waitingListId: 0,
      patientId: selectedPatient,
      doctorId: doctornm,
      weightKg: 0,
      bpSystolic: 0,
      bpDiastolic: 0,
      pulse: 0,
      temperature: 0,
      spo2: 0,
      appointmentTime: formattedAppointment,
      appointmentInTime: null,
      checkUpStatus: "WAITING",
      serialNo: null,
      refferBy: null,
      remove: false,
      errorMsg: null,
    };

    const token = getAuthToken();
    const apiChar = getApiChara();
    const fetchApi = `${apiChar}/waitingList/addPatientIntoWaitingList`;
    setIsLoading(true);
    try {
      const response = await fetch(fetchApi, {
        method: "post",
        body: JSON.stringify(patientData),
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        const resText = await response.text();
        let errorMsg = resText || "Network response was not ok";
        try {
          const resData = JSON.parse(resText);
          errorMsg = resData.message || resData.errorMsg || errorMsg;
        } catch (e) {
          if (resText.includes("Patient already Admitted")) {
            toast.error("Patient already available");
            setIsLoading(false);
            return;
          }
        }
        throw new Error(errorMsg);
      }

      const data = await response.json();
      props.updatePatientData(data);

      setPatientData([]);
      toast.success(t("Patient added to waiting list successfully!"));
    } catch (error) {
      console.error(
        "There has been a problem with your fetch operation:",
        error
      );
      if (error.message !== "Patient already available") {
        toast.error(t("There has been a problem with your fetch operation"));
        const errMsg = t("Server is offline");
        const errDesc = t("check your internet connection");
        navigate(`/access-denied?errorCode=500&errorMessage=${encodeURIComponent(errMsg)}&errorDescription=${encodeURIComponent(errDesc)}`);
      }
    }
    finally {
      setIsLoading(false); // Hide loader after fetching data
    }
  };
  return (
    <>
      {isLoading && <Loader />}
      <div className="container-fluid mt-2 px-3">
        <h4 className={classes.headerPremium}>{t("Today's Appointments")}</h4>

        <div className="row g-2 align-items-center mb-3">
          {/* Row 1 on mobile, part of row on desktop */}
          <div className="col-12 col-md-auto">
            <div className="d-flex align-items-center">
              <label className="me-2 mb-0 text-nowrap fw-bold text-secondary small d-none d-md-block">{t("Book Appointment:")}</label>
              <label className="me-2 mb-0 text-nowrap fw-bold text-secondary small d-md-none" style={{ fontSize: '11px' }}>{t("Book:")}</label>
              <input
                type="datetime-local"
                className={classes.formControlModern}
                value={appointmentDate}
                min={todayDate}
                onChange={(e) => setAppointmentDate(e.target.value)}
                style={{ width: '220px' }}
              />
            </div>
          </div>

          {/* Row 2 on mobile: side by side, part of row on desktop */}
          <div className="col-6 col-md-auto">
            <div className="d-flex align-items-center">
              <label className="me-2 mb-0 text-nowrap fw-bold text-secondary small d-none d-md-block">{t("Select Doctor:")}</label>
              <select
                id="drName"
                className={classes.selectModern}
                onChange={onChangeDoctorHandler}
                required
                value={doctornm?.userId}
                style={{ width: '200px' }}
              >
                {doctorData.map((doctor) => (
                  <option key={doctor.userId} value={doctor.userId}>
                    {doctor.firstName} {doctor.lastName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-6 col-md">
            <form onSubmit={onSearchPatientHandler}>
              <div className="input-group flex-nowrap">
                <input
                  type="text"
                  className={classes.formControlModern}
                  placeholder={t("Search Patient...")}
                  onChange={getSerachParaHandler}
                  required
                  style={{ borderTopRightRadius: '0', borderBottomRightRadius: '0', borderRight: 'none' }}
                />
                <button className={classes.searchBtn} type="submit">
                  <i className="fa fa-search"></i>
                </button>
              </div>
            </form>
          </div>

          {/* Row 3 on mobile: centered, part of row on desktop */}
          <div className="col-12 col-md-auto text-center text-md-end mt-2 mt-md-0">
            <button className={classes.premiumBtn} onClick={newPatientHandler}>
              <i className="fa fa-user-plus me-2"></i> {t("NEW PATIENT")}
            </button>
          </div>
        </div>
      </div>

      <div className={classes.tableContainer}>
        <Table responsive hover className={classes.customTable}>
          <thead>
            <tr>
              <th style={{ width: '120px' }}>{t("Patient Id")}</th>
              <th className="text-start ps-md-5 ps-2">{t("Patient Name")}</th>
              <th>{t("Mobile Number")}</th>
              <th style={{ width: '150px' }}>{t("Action")}</th>
            </tr>
          </thead>
          <tbody>
            {patientData.length === 0 && (
              <tr>
                <td colSpan="4" className={classes.noData}>
                  <i className="fa fa-folder-open mb-2"></i>
                  {t("No patients found. Search to add to waiting list.")}
                </td>
              </tr>
            )}
            {patientData.map((patient) => (
              <tr key={patient?.patientId}>
                <td>
                  <span className="badge rounded-pill bg-light text-dark border p-2px">
                    {patient?.patientId}
                  </span>
                </td>
                <td className="text-start ps-md-5 ps-2 fw-500">
                  {`${patient?.firstName || ""} ${patient?.middleName ? patient.middleName + " " : ""}${patient?.lastName || ""}`.trim()}
                </td>
                <td>{patient?.mobile || "-"}</td>
                <td>
                  <form onSubmit={(e) => addPatientToWaitingHandler(e, patient)}>
                    <button className={`${classes.actionBtn} d-flex align-items-center`} type="submit" disabled={isLoading}>
                      {isLoading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
                      {t("Select")}
                    </button>
                  </form>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default ScheduleAppointment;
